import { Header } from "../components/ui/header.jsx";
import { useState, useEffect } from "react";
import axios from "axios";
import { Footer } from "../components/ui/footer.jsx";
import { Blogs } from "../components/ui/blogs.jsx";
import { money } from "../utilities/currency.js";

const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Advokatene",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill konsultasjon",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};

type BlogsPageProps = {
    baseUrl: string,
    currentUser: any,
    onLoginClick: any,
    onLoginSuccess: any,
    onLogout: any,
    client: any,
}

export default function BlogsPage({ baseUrl, currentUser, onLoginClick, onLoginSuccess, onLogout, client }: BlogsPageProps) {

    const [scrolled, setScrolled] = useState(false);
    const [wallet, setWallet] = useState(0);
    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])

    const theme_settings = client ? JSON.parse(client.theme_settings) : {};

    const primaryColor = theme_settings.primaryColor || "#7c3aed"; // default purple-700
    const secondaryColor = theme_settings.secondaryColor || "#ec4899";

    const [appearance, setAppearance] = useState({
        gradientEnabled: false,
        gradientFrom: `${primaryColor}`,
        gradientTo: `${secondaryColor}`,
    });

    useEffect(() => {
        setAppearance(prev => ({
            gradientFrom: theme_settings.primaryColor,
            gradientTo: theme_settings.secondaryColor,
            gradientEnabled: theme_settings.useGradient === "true",
        }));
    }, [theme_settings.useGradient]);

    return (
        <div style={{
            "--primary-color": primaryColor,
            "--secondary-color": secondaryColor,
        }} className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} />
            <Blogs T={T} from={"blogpage"} />
            <Footer baseUrl={baseUrl} />
        </div>
    )
}